import React from "react";
import { Link } from "react-router-dom";
import {
  FaAudible,
  FaBullhorn,
  FaCar,
  FaFax,
  FaGlobeAfrica,
} from "react-icons/fa";
import { getGenerals } from "../../store/api";
import { store } from "../../store";

export default class HomeExtras extends React.Component {
  constructor() {
    super();
    this.state = {
      didViewCountUp: false,
      data: null,
      isLoading: true,
      error: null,
    };
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ didViewCountUp: true });
    }
  };

  componentDidMount() {
    // Dispatch the API call manually
    store
      .dispatch(getGenerals.initiate()) // Calls the API
      .unwrap() // Unwraps the promise to get actual data
      .then((data) => {
        this.setState({ data, isLoading: false });
      })
      .catch((error) => {
        this.setState({ error, isLoading: false });
      });

    const $ = window.$; // Ensure jQuery is available
    if ($(".video-popup").length) {
      $(".video-popup").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false,
      });
    }
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let aboutVideo =
      this.state.data && this.state.data[0]?.about_video
        ? this.state.data[0]?.about_video
        : "";

    return (
      <>
        {/* About Section */}
        <section className="about-section">
          <div className="container">
            <div className="section-title text-center">
              <span className="section-title__tagline">Who We Are</span>
              <h2 className="section-title__title">
                Concept Multi-Services Nig
              </h2>
            </div>
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <div className="about-left">
                  <div
                    className="about-img-box about-one__left wow slideInLeft"
                    data-wow-delay="100ms"
                    data-wow-duration="2500ms"
                  >
                    <div className="about-img about-one__img-box">
                      <img
                        src={
                          publicUrl +
                          "assets/images/resources/about-one-img-1.jpg"
                        }
                        alt=""
                        className="about-one__img"
                      />
                    </div>
                    <div
                      className="about-img-2 about-one__small-img wow zoomIn animated animated d-none"
                      data-wow-delay="500ms"
                      data-wow-duration="2500ms"
                    >
                      <img
                        src={
                          publicUrl +
                          "assets/images/resources/about-one-small-img.jpg"
                        }
                        alt=""
                        width={"50px"}
                      />
                    </div>
                    <div className="about-shape-1"></div>
                    <div className="about-shape-2"></div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6" style={{zIndex: 10}}>
                <div className="about-right">
                  <div className="section-title">
                    <h2 className="section-title__title">
                      A full-service consultancy with multiple focus areas
                    </h2>
                  </div>
                  <div className="about-right__text">
                    <p>
                      Concept Multi-Services Nig is a full-service consultancy
                      with focus on Entertainment and Culture, Branding and
                      Advertising, Automobile Purchase/Sales and Services,
                      Tourist Services, and Diaspora Bridge Services.
                    </p>
                  </div>
                  <div className="about-right__bottom">
                    <div className="about-right__bottom-icon">
                      <span className="icon-checklist"></span>
                    </div>
                    <div className="about-right__bottom-text">
                      <h3>Our Mission</h3>
                      <p>
                        To entertain, inform and inspire humanity through the
                        power of unparalleled focus in our work, reflecting the
                        iconic brands, creative minds and innovative techniques
                        that make life a better living.
                      </p>
                    </div>
                  </div>
                  <div className="about-right__bottom">
                    <div className="about-right__bottom-icon">
                      <span className="icon-visibility"></span>
                    </div>
                    <div className="about-right__bottom-text">
                      <h3>Our Vision</h3>
                      <p>
                        To be among the world's leading service driven
                        organization.
                      </p>
                    </div>
                  </div>
                  <div className="about-one__bottom-video-box">
                    <div className="about-one__btn-box">
                      <Link
                        to={process.env.PUBLIC_URL + `/about`}
                        className="thm-btn about-right__btn"
                      >
                        Discover More
                      </Link>
                    </div>
                    <div
                      className={`about-one__video-link ${
                        aboutVideo ? "" : "d-none"
                      }`}
                    >
                      <a href={aboutVideo} className="video-popup">
                        <div className="about-one__video-icon">
                          <span className="fa fa-play"></span>
                          <i className="ripple"></i>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="services-section">
          <div className="container">
            <div className="section-title text-center">
              <span className="section-title__tagline">Our Services</span>
              <h2 className="section-title__title">What We Do</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="services-one__single wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="services-one__icon">
                    <FaAudible
                      className="icon-audible"
                      fontSize={"84px"}
                      color="var(--sopot-base)"
                    />
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link
                        to={
                          process.env.PUBLIC_URL + `/what-we-do#entertainment`
                        }
                      >
                        Entertainment and Culture
                      </Link>
                    </h3>
                    <p className="services-one__text">
                      With entertainment and culture, we inspire people to take
                      delight in promoting and supporting societal development
                      using the power of entertainment irrespective of
                      diversity; upholding our beliefs in race, ethnicity, norms
                      and the value of humanity.
                    </p>
                    <div className="services-one__bottom">
                      <Link
                        to={
                          process.env.PUBLIC_URL + `/what-we-do#entertainment`
                        }
                        className="services-one__btn"
                      >
                        Read More
                      </Link>
                      <Link
                        to={
                          process.env.PUBLIC_URL + `/what-we-do#entertainment`
                        }
                        className="services-one__arrow"
                      >
                        <span className="icon-right-arrow"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="services-one__single wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="services-one__icon">
                    <FaBullhorn fontSize={"64px"} color="var(--sopot-base)" />
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link to={process.env.PUBLIC_URL + `/branding`}>
                        Branding and Advertising
                      </Link>
                    </h3>
                    <p className="services-one__text">
                      We help brands and businesses achieve their goals through
                      compelling campaigns that will resonate with their target
                      audience and drive business results. Our strategic
                      approach combines creative excellence with market
                      intelligence.
                    </p>
                    <div className="services-one__bottom">
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#branding`}
                        className="services-one__btn"
                      >
                        Read More
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#branding`}
                        className="services-one__arrow"
                      >
                        <span className="icon-right-arrow"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="services-one__single wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="services-one__icon">
                    <FaCar
                      className="icon-automobile"
                      fontSize={"84px"}
                      color="var(--sopot-base)"
                    />
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#automobile`}
                      >
                        Automobile Purchase/Sales
                      </Link>
                    </h3>
                    <p className="services-one__text">
                      Finding the perfect vehicle to match your lifestyle is our
                      specialty. Our transparent process puts you in control,
                      offering premium selection, competitive pricing, and
                      personalized service for all your automotive needs.
                    </p>
                    <div className="services-one__bottom">
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#automobile`}
                        className="services-one__btn"
                      >
                        Read More
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#automobile`}
                        className="services-one__arrow"
                      >
                        <span className="icon-right-arrow"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="services-one__single wow fadeInUp"
                  data-wow-delay="400ms"
                >
                  <div className="services-one__icon">
                    <FaFax
                      className="icon-tourism"
                      fontSize={"64px"}
                      color="var(--sopot-base)"
                    />
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link to={process.env.PUBLIC_URL + `/tourism`}>
                        Tourist Services
                      </Link>
                    </h3>
                    <p className="services-one__text">
                      Explore destinations like a local while enjoying the
                      confidence of expert guidance. Our curated experiences
                      transform ordinary trips into extraordinary journeys,
                      creating memories that last a lifetime.
                    </p>
                    <div className="services-one__bottom ">
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#tourism`}
                        className="services-one__btn"
                      >
                        Read More
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#tourism`}
                        className="services-one__arrow"
                      >
                        <span className="icon-right-arrow"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="services-one__single wow fadeInUp"
                  data-wow-delay="500ms"
                >
                  <div className="services-one__icon">
                    <FaGlobeAfrica
                      className="icon-diaspora"
                      fontSize={"64px"}
                      color="var(--sopot-base)"
                    />
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#diaspora`}
                      >
                        Diaspora Bridge Services
                      </Link>
                    </h3>
                    <p className="services-one__text">
                      Living abroad but need someone you can trust on the ground
                      in Nigeria? We act as your reliable personal assistant
                      back home — property checks, errands, deliveries,
                      family check-ins and more — keeping you informed every
                      step of the way.
                    </p>
                    <div className="services-one__bottom">
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#diaspora`}
                        className="services-one__btn"
                      >
                        Read More
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + `/what-we-do#diaspora`}
                        className="services-one__arrow"
                      >
                        <span className="icon-right-arrow"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Custom CSS */}
        <style jsx>
          {`
            /* Common Styling */
            .section-title__tagline {
              position: relative;
              display: block;
              color: var(--thm-primary);
              font-size: 16px;
              line-height: 26px;
              font-weight: 700;
              text-transform: uppercase;
              letter-spacing: 0.1em;
              margin-bottom: 10px;
            }

            .section-title__title {
              margin: 0;
              font-size: 40px;
              line-height: 50px;
              font-weight: 700;
              margin-bottom: 30px;
            }

            .section-title.text-center {
              max-width: 700px;
              margin: 0 auto 60px;
            }

            /* About Section */
            .about-section {
              position: relative;
              padding: 120px 0;
              z-index: 10;
              background-color: #ffffff;
            }

            .about-img-box {
              position: relative;
              display: block;
              margin-right: 70px;
            }

            .about-img {
              position: relative;
              display: block;
              overflow: hidden;
              border-radius: 10px;
            }

            .about-img img {
              width: 100%;
              transform: scale(1);
              transition: transform 500ms ease;
            }

            .about-img:hover img {
              transform: scale(1.05);
            }

            .about-img-2 {
              position: absolute;
              right: -70px;
              bottom: -70px;
              max-width: 270px;
              overflow: hidden;
              border-radius: 10px;
              z-index: 1;
            }

            .about-shape-1 {
              position: absolute;
              top: -50px;
              left: -50px;
              width: 120px;
              height: 120px;
              background-color: var(--thm-primary);
              border-radius: 50%;
              z-index: -1;
            }

            .about-shape-2 {
              position: absolute;
              top: -35px;
              right: 0;
              width: 70px;
              height: 70px;
              background-color: var(--thm-black);
              border-radius: 50%;
              z-index: -1;
            }

            .about-right {
              position: relative;
              display: block;
              margin-left: 30px;
              margin-top: 30px;
            }

            .about-right__text {
              margin-bottom: 30px;
            }

            .about-right__bottom {
              display: flex;
              align-items: flex-start;
              margin-bottom: 30px;
            }

            .about-right__bottom-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 60px;
              width: 60px;
              background-color: rgba(var(--thm-primary-rgb), 0.1);
              border-radius: 50%;
              margin-right: 20px;
              flex-shrink: 0;
            }

            .about-right__bottom-icon span {
              color: var(--thm-primary);
              font-size: 28px;
            }

            .about-right__bottom-text h3 {
              font-size: 20px;
              font-weight: 700;
              line-height: 30px;
              margin-bottom: 10px;
            }

            .about-right__btn-box {
              margin-top: 40px;
            }

            /* Stats Section */
            .counter-section {
              position: relative;
              padding: 80px 0;
              overflow: hidden;
            }

            .counter-section__bg {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
              z-index: -1;
              opacity: 0.6;
            }

            .counter-section:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.7);
              z-index: -1;
            }

            .counter-one__single {
              position: relative;
              text-align: center;
              padding: 60px 30px;
              transition: all 500ms ease;
            }

            .counter-one__single:hover {
              transform: translateY(-10px);
            }

            .counter-one__icon {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 80px;
              width: 80px;
              background-color: rgba(255, 255, 255, 0.1);
              border-radius: 50%;
              margin: 0 auto 20px;
            }

            .counter-one__icon span {
              color: var(--thm-primary);
              font-size: 44px;
            }

            .counter-one__count-box {
              font-size: 48px;
              line-height: 48px;
              color: #ffffff;
              font-weight: 700;
              margin-bottom: 10px;
            }

            .counter-one__title h3 {
              color: #ffffff;
              font-size: 18px;
              font-weight: 600;
              margin: 0;
            }

            /* Services Section */
            .services-section {
              position: relative;
              padding: 120px 0 90px;
              background-color: #f8f8f8;
            }

            .services-one__single {
              position: relative;
              display: block;
              margin-bottom: 30px;
              background-color: #ffffff;
              border-radius: 10px;
              padding: 50px 40px 40px;
              transition: all 500ms ease;
              z-index: 1;
              overflow: hidden;
            }

            .services-one__single:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 3px;
              background-color: var(--thm-primary);
              transition: all 500ms ease;
            }

            .services-one__single:hover {
              box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.08);
              transform: translateY(-10px);
            }

            .services-one__icon {
              height: 80px;
              width: 80px;
              background-color: rgba(var(--thm-primary-rgb), 0.1);
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              margin-bottom: 25px;
              position: relative;
              z-index: 1;
              transition: all 500ms ease;
            }

            .services-one__icon:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              border-radius: 50%;
              background-color: var(--thm-primary);
              transform: scale(0);
              transform-origin: center;
              transition: transform 500ms ease;
              z-index: -1;
            }

            .services-one__single:hover .services-one__icon:before {
              transform: scale(1);
            }

            .services-one__icon span {
              color: var(--thm-primary);
              font-size: 44px;
              transition: all 500ms ease;
            }

            .services-one__single:hover .services-one__icon span {
              color: #ffffff;
            }

            .services-one__title {
              font-size: 24px;
              font-weight: 700;
              margin-bottom: 15px;
            }

            .services-one__title a {
              color: var(--thm-black);
              transition: all 500ms ease;
            }

            .services-one__title a:hover {
              color: var(--thm-primary);
            }

            .services-one__text {
              margin-bottom: 30px;
            }

            .services-one__bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .services-one__btn {
              font-size: 14px;
              color: var(--thm-black);
              font-weight: 700;
              text-transform: uppercase;
              position: relative;
              transition: all 500ms ease;
            }

            .services-one__btn:before {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background-color: var(--thm-primary);
              transform: scale(0, 1);
              transform-origin: right center;
              transition: transform 500ms ease;
            }

            .services-one__btn:hover {
              color: var(--thm-primary);
            }

            .services-one__btn:hover:before {
              transform: scale(1, 1);
              transform-origin: left center;
            }

            .services-one__arrow {
              height: 40px;
              width: 40px;
              background-color: var(--thm-base);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 500ms ease;
            }

            .services-one__arrow span {
              color: #ffffff;
              font-size: 14px;
              transform: rotate(-45deg);
              transition: all 500ms ease;
            }

            .services-one__arrow:hover {
              background-color: var(--thm-primary);
            }

            .services-one__arrow:hover span {
              transform: rotate(0);
            }

            /* CTA Section */
            .cta-one {
              position: relative;
              padding: 0;
              z-index: 1;
            }

            .cta-one__bg {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
              z-index: -1;
            }

            .cta-one:before {
            }
          `}
        </style>
      </>
    );
  }
}
